import { default as AbstractScene } from './AbstractScene'
import { VARS } from '../config'
import * as THREE from 'three'
import { gsap } from '../gsap'


export default class SceneMenu extends AbstractScene {

    static get settings() {
        const h = 1
        return {
            CLASS_DISABLED: 'is-disabled',
            animationDuration: 0.8,
            cubePoints: new Float32Array([
                - h, - h, - h,
                - h, h, - h,
                h, h, - h,
                h, - h, - h,
                - h, - h, - h,

                - h, - h, h,
                - h, h, h,
                - h, h, - h,
                - h, h, h,

                h, h, h,
                h, h, - h,
                h, h, h,

                h, - h, h,
                h, - h, - h,
                h, - h, h,
                - h, - h, h,
            ]),
            states: [
                // 00 — Home
                {
                    rotation: {
                        x: -1,
                        y: 1,
                        z: 0,
                    },
                    twist: Math.PI/2,
                },
                // 01 — Projects
                {
                    rotation: {
                        x: 0,
                        y: -1,
                        z: -1,
                    },
                    twist: -Math.PI/4,
                },
                // 02 — Areas
                {
                    rotation: {
                        x: 1,
                        y: 0,
                        z: 1,
                    },
                    twist: Math.PI/4,
                },
                // 03 — Partnership
                {
                    rotation: {
                        x: -1,
                        y: 1,
                        z: 0,
                    },
                    twist: Math.PI/2,
                },
                // 04 — Team
                {
                    rotation: {
                        x: 0,
                        y: -1,
                        z: 1,
                    },
                    twist: -Math.PI/4,
                },
                // 05 — Careers
                {
                    rotation: {
                        x: 1,
                        y: 1,
                        z: -1,
                    },
                    twist: Math.PI/4,
                },
                // 06 — Journal
                {
                    rotation: {
                        x: 1,
                        y: 0,
                        z: 1,
                    },
                    twist: -Math.PI/2,
                }
            ]
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$points = Array.from(this.$('point'))
        this.$images = Array.from(this.$('image'))

        // Vars
        this.currentIndex = -1

        // Clean HTML
        this.$el.removeAttribute('data-images')
    }

    onInit() {
        this.isDisabled = VARS.window.width < 1000

        if (this.isDisabled) {
            this.$el.classList.add(SceneMenu.settings.CLASS_DISABLED)
            return
        }

        gsap.set(this.$images, {
            rotationX: -90,
            yPercent: 100,
            z: -100,
        })

        this.camera.position.z = VARS.window.width > VARS.window.height ? 3 : 5

        const material = new THREE.LineBasicMaterial({
            color: 0x1657E8,
        })
        // this.geometry = new THREE.BufferGeometry().setFromPoints(SceneMenu.settings.cubePoints)
        this.geometry = new THREE.BufferGeometry()
        this.geometry.setAttribute('position', new THREE.BufferAttribute( SceneMenu.settings.cubePoints, 3 ))
        this.geometry.computeVertexNormals()
        this.mesh = new THREE.Line(this.geometry, material)

        // Twist mesh
        this.twist(-Math.PI/8)

        this.scene.add(this.mesh)

        // Prevent render
        this.stop()
    }

    onResize() {

        // Update sizes
        this.sizes.width = this.$el.offsetWidth
        this.sizes.height = this.$el.offsetHeight

        if (this.isDisabled && VARS.window.width >= 1000) {
            this.isDisabled = false
            this.$el.classList.remove(SceneMenu.settings.CLASS_DISABLED)
            this.init()
        } else if (!this.isDisabled && VARS.window.width < 1000) {
            this.isDisabled = true
            this.$el.classList.add(SceneMenu.settings.CLASS_DISABLED)
            this.renderer.domElement.remove()
        }
    }

    animate(index) {

        if(this.isDisabled) {
            return
        }

        this.start()

        if(!this.mesh) {
            return
        }

        clearTimeout(this.onAnimationComplete)
        this.onAnimationComplete = setTimeout(() => {
            this.stop()
        }, 1000 * SceneMenu.settings.animationDuration)

        if(this.currentIndex > -1) {
            // Hide image
            gsap.to(this.$images[this.currentIndex], {
                rotationX: 45,
                yPercent: -100,
                z: -100,
                scale: 0.9,
                // opacity: 0,
                duration: 0.5 * SceneMenu.settings.animationDuration,
                ease: 'power2.out',
                overwrite: true,
            })

            gsap.to(this.mesh.scale, {
                x: 0.8,
                y: 0.8,
                z: 0.8,
                duration: 0.25 * SceneMenu.settings.animationDuration,
                ease: 'power2.in',
            })
        }

        if (index < 0) {

            // Rotate object
            gsap.set(this.mesh.rotation, {
                x: 0,
                y: 0,
                z: 0,
            })

        } else {

            const state = SceneMenu.settings.states[index]

            // Rotate object
            gsap.to(this.mesh.rotation, {
                x: state.rotation.x,
                y: state.rotation.y,
                z: state.rotation.z,
                duration: SceneMenu.settings.animationDuration,
                ease: 'power2.out',
            })

            gsap.to(this.mesh.scale, {
                x: 1,
                y: 1,
                z: 1,
                duration: 0.75 * SceneMenu.settings.animationDuration,
                delay: 0.25 * SceneMenu.settings.animationDuration,
                ease: 'power2.out',
            })

            gsap.fromTo(this.$images[index],
                {
                    rotationX: -90,
                    yPercent: 100,
                    z: -100,
                    scale: 0.9,
                    // opacity: 0,
                },
                {
                    rotationX: 0,
                    yPercent: 0,
                    z: 0,
                    scale: 1,
                    // opacity: 1,
                    duration: 0.75 * SceneMenu.settings.animationDuration,
                    // delay: 0.25 * SceneMenu.settings.animationDuration,
                    ease: 'power2.out',
                }
            )

            this.currentIndex = index


            // const positions = this.twist(state.twist)
            // gsap.to(this.mesh.geometry.attributes.position.array, {
            //     endArray: positions,
            //     duration: 0.8,
            //     // Make sure to tell it to update
            //     onUpdate: () => {
            //         this.mesh.geometry.computeVertexNormals()
            //         this.mesh.geometry.attributes.position.needsUpdate = true

            //         this.$points.forEach(($point, i) => {
            //             // const screenPosition = this.objectPoints[i].clone()
            //             const screenPosition = new THREE.Vector3(positions[3 * i], positions[3 * i + 1], positions[3 * i + 2])
            //             // const screenPosition = {
            //             //     x: this.mesh.geometry.attributes.position.array[3 * i],
            //             //     y: this.mesh.geometry.attributes.position.array[3 * i + 1],
            //             //     z: this.mesh.geometry.attributes.position.array[3 * i + 2],
            //             // }
            //             // const screenPosition = this.mesh[i].clone()
            //             screenPosition.project(this.camera)

            //             if (i === 0) {
            //                 console.log(screenPosition.x, screenPosition.y)
            //             }

            //             $point.style.setProperty('--menu-point-x', `${screenPosition.x * 0.5 * this.sizes.width}px`)
            //             $point.style.setProperty('--menu-point-y', `${screenPosition.y * 0.5 * this.sizes.height}px`)
            //         })
            //     }
            // })
        }
    }

    // onRender() {
    //     const position = this.geometry.attributes.position.array
    //     this.geometry.computeVertexNormals()

    //     this.$points.forEach(($point, i) => {
    //         const screenPosition = new THREE.Vector3(position[3 * i], position[3 * i + 1], position[3 * i + 2])
    //         screenPosition.project(this.camera)

    //         $point.style.setProperty('--menu-point-x', `${screenPosition.x * 0.5 * this.sizes.width}px`)
    //         $point.style.setProperty('--menu-point-y', `${screenPosition.y * 0.5 * this.sizes.height}px`)
    //     })
    // }

    twist(factor) {
        const q = new THREE.Quaternion()
        const up = new THREE.Vector3(0, 1, 0)
        // const p = [...this.geometry.attributes.position.array]
        const p = this.geometry.attributes.position.array

        for (let i = 0; i < p.length; i += 3) {
            q.setFromAxisAngle(up, p[i + 1] * factor)

            let vec = new THREE.Vector3(p[i], p[i + 1], p[i + 2])
            vec.applyQuaternion(q)

            p[i] = vec.x
            p[i + 2] = vec.z
        }

        // return new Float32Array(p)

        this.mesh.geometry.computeVertexNormals()
        this.mesh.geometry.attributes.position.needsUpdate = true
    }

    destroy() {
    }
}
